import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
});

export interface VerifyResult {
  employeeId: number;
  name: string;
  email: string;
  status: string;
  availableDocuments: string[];
  joinDate: string | null;
  endDate: string | null;
}

export interface IssuePayload {
  employeeId: number;
  name: string;
  birthdate: string;
  documentType: string;
  address?: string;
  purpose: string;
  recipientEmail: string;
  year?: number;
  submissionOrg?: string;
  submissionPurpose?: string;
}

export const hrDocumentApi = {
  verify: async (name: string, birthdate: string): Promise<VerifyResult> => {
    const res = await api.post('/hr-document/verify', { name, birthdate });
    return res.data.data;
  },

  issue: async (payload: IssuePayload): Promise<void> => {
    await api.post('/hr-document/issue', payload);
  },
};
